import React from 'react';
import AssignTab from '../assign/Assign';
import CapitalContributionTab from './siteReviewInfo/capitalContribution/CapitalContribution';
import CompanyHistoryTab from './siteReviewInfo/companyHistory/CompanyHistory';
import CorporateIdTab from './siteReviewInfo/corporateId/CorporateId';
import CorporateOwnersTab from './siteReviewInfo/corporateOwners/CorporateOwners';
import EmployeeAndCompTab from './siteReviewInfo/employeeAndComp/EmployeeAndComp';
import FinalRecommTab from './siteReviewInfo/finalRecomm/FinalRecomm';
import OperationAndControlTab from './siteReviewInfo/operationAndControl/OperationAndControl';
import SiteInfoTab from './siteReviewInfo/siteInfo/SiteInfo';
import TourTab from './siteReviewInfo/tour/Tour';
import { SetupPage } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App'
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';

class SiteReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            list: [],
            loading: false,
            availableTabs: { }
        };
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
        this.getAvailableTabs();
    }

    getAvailableTabs = () => {
        var certificationKey = this.props.location.pathname.replace(this.props.match.path + "/", '');
        if (certificationKey.indexOf("/") > 0)
            certificationKey = certificationKey.substring(0, certificationKey.indexOf("/"));

        var rq = {
            certificationKey: certificationKey
        };

        new API().post(APIModules.Admin.url('/siteReview/getSiteReviewSetup'), rq,
            {
                success: (r) => {
                    this.setState(
                        {
                            availableTabs: r.data
                        }
                    );
                }
            });
    }

    handleBackToSearchQueue = () => {
        var params = "";
        if (App.context().searchQueueFilters)
            params = "?p=true";

        this.props.history.push('/admin/searchQueue' + params);
    }

    render() {
        var me = this; 
        var tabs = [
            { key: "siteInfo", title: "Site Info", comp: SiteInfoTab, helpKey: "" },
            { key: "corporateId", title: "Corp. ID", comp: CorporateIdTab, helpKey: "", disabled: this.state.availableTabs.corporateIdDisabled },
            { key: "corporateOwners", title: "Corp. Owners", comp: CorporateOwnersTab, helpKey: "", disabled: this.state.availableTabs.corporateOwnersDisabled },
            { key: "companyHistory", title: "Company History", comp: CompanyHistoryTab, helpKey: "", disabled: this.state.availableTabs.businessHistoryDisabled },
            { key: "capitalContribution", title: "Capital Contrib.", comp: CapitalContributionTab, helpKey: "", disabled: this.state.availableTabs.capitalContributionDisabled },
            { key: "operationAndControl", title: "Operation & Control", comp: OperationAndControlTab, helpKey: "", disabled: this.state.availableTabs.operationAndControlDisabled },
            { key: "employeeAndComp", title: "Employee & Comp", comp: EmployeeAndCompTab, helpKey: "", disabled: this.state.availableTabs.employeeAndCompDisabled },
            { key: "tour", title: "Tour", comp: TourTab, helpKey: "", disabled: this.state.availableTabs.tourDisabled }];

        tabs.push({ key: "finalRecomm", title: "Final Recommendation", comp: FinalRecommTab, helpKey: "" });

        if (App.hasPrivilege("UnassignedQueue"))
            tabs.push({ key: "assign", title: "Assign", comp: AssignTab, helpKey: "" });

        let opts = {
            title: "Application Details",
            description: "Search and Manage Applications",
            recentType: "certification",
            showTitle: false,
            tabs: tabs,
            _siteReview: me
        };

        opts = Object.assign(opts, this.props);

        return (
            <SetupPage {...opts}
                customOnBack={this.handleBackToSearchQueue} />
        );
    }
}

export default SiteReview;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/SiteReview.js